<main>
<app-header *ngIf= "getHeader"></app-header>
<router-outlet (activate)="changeOfRoutes($event)"></router-outlet>
<ngx-ui-loader></ngx-ui-loader>
</main>
<app-footer *ngIf= "getHeader"></app-footer>